<template>
	<ion-page>
		<spot-header :title="pageTitle" :canGoHome="true" :showLogo="false" @pressedGoHome="$router.push('/home')"></spot-header>
		<ion-header v-if="!isClosed && isActive">
			<ion-toolbar>
				<spot-button
					fill="outline"
					size="default"
					color="primary"
					icon="bagAdd"
					:enabled="(tablesData.currentProject.expected_project_rows_count - tablesData.currentProject.project_rows_count)>0 && !isClosed"
					:expand="null"
					text="Aggiungi Oggetto"
					@clicked="addNew()">
				</spot-button>
			</ion-toolbar>
		</ion-header>
		<ion-content :fullscreen="true">
			<ion-item v-if="!isActive || searchingData">
				<ion-spinner name="lines" color="primary"></ion-spinner>
				<ion-label color="primary">{{ spinnerText}}</ion-label>
			</ion-item>
			<div id="actionArea" v-if="isActive">
				<div class="results" v-if="showResults">
					<div class="package-title" v-if="packageCode">{{ labelPackage }} {{ packageCode }}</div>
					<div class="group-title">
						<ion-label v-if="tablesData.currentProject.receiving == true">{{ labelReceivingText }} ({{ tablesData.projectRows.length }} / {{ tablesData.currentProject.expected_project_rows_count }})</ion-label>
						<ion-label v-if="tablesData.currentProject.shipping == true">{{ labelShippingText }} ({{ tablesData.projectRows.length }} / {{ tablesData.currentProject.expected_project_rows_count }})</ion-label>
					</div>
					<ion-item v-for="element in tablesData.projectRows" :key="element.id" :color="checkDisposable(element) ? 'medium' : 'light'">
						<ion-label>{{element.code}}</ion-label>
						<ion-icon v-if="element.closed" :icon="bagCheck" color="success"></ion-icon>
						<ion-icon v-if="element.disposed" :icon="trashBin" color="danger"></ion-icon>
						<spot-button v-if="tablesData.currentProject.receiving == true" fill="solid" size="default" color="primary" icon="logInOutline" :expand="null" :text="buttonOpenText" @clicked="openReceipt(element.id)">
						</spot-button>
						<spot-button v-if="tablesData.currentProject.shipping == true" fill="solid" size="default" color="primary" icon="logOutOutline" :expand="null" :text="buttonOpenText" @clicked="openShipment(element.id)">
						</spot-button>
					</ion-item>
				</div>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.global.debug && tablesData.currentProject">
				<div>Test Area</div>
				Current Project: {{ tablesData.currentProject.id }}<br>
			</div>
		</ion-content>
		<ion-footer class="finalize" v-if="isActive && (tablesData.currentProject.expected_project_rows_count - tablesData.currentProject.project_rows_count)==0 && !isClosed && tablesData.projectRows.length > 0">
			<spot-button
				fill="solid"
				size="default"
				color="primary"
				icon="downloadOutline"
				:enabled="(tablesData.currentProject.expected_project_rows_count - tablesData.currentProject.project_rows_count)==0 && !isClosed"
				:expand="null"
				:text="tablesData.currentProject.receiving == true ? labelWithdrawText : (tablesData.currentProject.shipping == true ? labelDeliveryText : null)"
				@clicked="finalizeAll()">
			</spot-button>
		</ion-footer>
	</ion-page>
</template>

<style src="vue-multiselect/dist/vue-multiselect.css"></style> <!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
<style scoped>
	ion-label {
		font-weight:bold;
	}
	.results {
		margin-top: .5em;
	}
	ion-item {
		margin-left: .5em;
		margin-right: .5em;
	}
	.package-title {
		font-weight: bold;
		text-align: center;
	}
	.group-title {
		font-weight: bold;
		margin-left: 3em;
		margin-top: 1em;
	}
	.finalize {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: row;
		background-color: white;
	}
	/*
	.finalize:deep(*) {
		margin-top: 0em;
	}
	*/
</style>

<script>
	import { IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonPage, IonToolbar, IonSpinner } from "@ionic/vue";
	import { bagAdd, bagCheck, downloadOutline, logInOutline, logOutOutline, trashBin } from "ionicons/icons";
	import { defineComponent } from "vue";
	import SpotButton from "../components/SpotButton.vue";
	import SpotHeader from "../components/SpotHeader.vue";
	import { showMsgWarning } from "../plugins/common.js";
	import { settings } from "../plugins/settings.js";
	import { getProject, getPastDate, jsonSearchProjectRows, tablesData } from '../plugins/customDatabase.js';

	export default defineComponent({
		name: "RevisionMultiple",
		props: {
			pageTitle: { type: String, default: "Ritiri/Consegne Multiple" },
			defaultSpinnerText: { type: String, default: "Caricamento..." },
			loadingProjectText: { type: String, default: "Caricamento Consegna/Ritiro Multiplo..." },
			loadingSearchedItemsText: { type: String, default: "Caricamento Risultati..." },
			buttonOpenText: { type: String, default: "Apri" },
			labelReceivingText: { type: String, default: "RICEZIONI" },
			labelWithdrawText: { type: String, default: "Consegna tutti" },
			labelShippingText: { type: String, default: "SPEDIZIONI" },
			labelDeliveryText: { type: String, default: "Spedisci tutti" },
			messageTitle: { type: String, default: "RICERCA RICEZIONI/SPEDIZIONI" },
			labelPackage: { type: String, default: "Oggetti in:" },
			warningUpdateMessage: { type: String, default: "Non ci sono articoli da movimentare" },
		},
		components: {
			IonPage,
			IonContent,
			IonSpinner,
			IonHeader,
			IonToolbar,
			IonItem,
			IonLabel,
			IonIcon,
			IonFooter,
			SpotHeader,
			SpotButton,
		},
		data: () => ({
			isActive: null,
			isClosed: null,
			showResults: false,
			projectId: null,
			packageCode: null,
			disposableDate: null,
			spinnerText: null,
			searchingData: null,
			openedRowsCount: 0,
			logInOutline,
			logOutOutline,
			bagAdd,
			bagCheck,
			trashBin,
			downloadOutline,
			settings,
			showMsgWarning,
			getProject,
			getPastDate,
			jsonSearchProjectRows,
			tablesData,
		}),
		computed: {
			allProjectRows() {
				return {
					q: {
						'project_id_eq': this.projectId,
					},
				}
			},
			allOpenedProjectRows() {
				return {
					q: {
						'project_id_eq': this.projectId,
						'closed_eq': false, //to show only not closed
					},
				}
			},
		},
		async ionViewWillEnter() {
			this.getUrlParamsAndQuery();
			await this.setDefault();
			await this.getAllTablesData();
			await this.acquireProjectRows();
			this.isClosed = (this.tablesData.currentProject && this.tablesData.currentProject.closed) ? true : false;
			this.isActive=true;
		},
		ionViewWillLeave() {
			document.activeElement?.blur();
			this.isActive=false;
		},
		methods: {
			//Settings
			async getUrlParamsAndQuery() {
				if (this.$route.params.id) {
					this.projectId	= this.$route.params.id;
					this.packageCode = this.$route.query.code;
				}
				else {
					this.projectId	= null;
					this.packageCode = null;
				}
			},
			//Database
			async getAllTablesData() {
				if (this.projectId) {
					this.searchingData = true;
					this.spinnerText = this.loadingProjectText;
					await this.getProject(this.projectId);
					this.searchingData = false;
				}
			},
			checkDisposable(elementToCheck) {
				return (elementToCheck.closed == false && elementToCheck.disposed == false && elementToCheck.created_at < this.disposableDate);
			},
			async searchRecords(currSearch) {
				this.spinnerText = this.loadingSearchedItemsText;
				this.searchingData = true;
				// this.tablesData.projectRows = [];
				await this.jsonSearchProjectRows(currSearch);
				this.searchingData = false;
				if (this.tablesData.projectRows) {
					this.showResults = true;
				}
			},
			async searchOpenedProjectRows() {
				if (this.projectId) {
					this.openedRowsCount = 0;
					await this.searchRecords(this.allOpenedProjectRows);
					this.openedRowsCount = this.tablesData.projectRows.length;
				}
			},
			//Actions
			async acquireProjectRows() {
				if (this.projectId) {
					await this.searchRecords(this.allProjectRows);
				}
				else {
					this.packageCode = null;
				}
			},
			openReceipt(movementId) { //TODO: da rivedere meglio perchè non dovrebbe punate qui
				this.$router.push(`/finalize/receipt/` + movementId + `?multipack=true`);
			},
			openShipment(movementId) { //TODO: da rivedere meglio perchè non dovrebbe punate qui
				this.$router.push(`/finalize/shipment/` + movementId + `?multipack=true`);
			},
			async setDefault() {
				this.spinnerText = this.defaultSpinnerText;
				this.isClosed = false;
				this.searchingData = false;
				this.disposableDate = await getPastDate(this.settings.global.disposeWaitingDays);
			},
			async finalizeAll() {
				await this.searchOpenedProjectRows();
				if (this.openedRowsCount>0) {
					if (this.tablesData.currentProject.receiving == true) this.$router.push(`/finalize/receipt?header_id=${this.projectId}` + `&multipack=true`); // `/finalize/receipt?header_id=` + this.tablesData.currentProject.id + `&multipack=true`
					if (this.tablesData.currentProject.shipping == true) this.$router.push(`/finalize/shipment?header_id=${this.projectId}` + `&multipack=true`); // `/finalize/shipment?header_id=` + this.tablesData.currentProject.id + `&multipack=true`
				}
				else {
					this.showMsgWarning(this.messageTitle,this.warningUpdateMessage);
				}
			},
			addNew() {
				if (this.tablesData.currentProject.receiving == true) this.$router.push(`/insert/receipt?header_id=${this.projectId}` + `&multipack=true`); // `/insert/receipt?header_id=` + this.tablesData.currentProject.id + `&multipack=true`
				if (this.tablesData.currentProject.shipping == true) this.$router.push(`/insert/shipment?header_id=${this.projectId}` + `&multipack=true`); // `/insert/shipment?header_id=` + this.tablesData.currentProject.id + `&multipack=true`
			}
		},
	});
</script>